// auth/auth.routes.ts
import { Routes } from '@angular/router';
import { ResetPasswordGuard } from '@core/guard/reset-guard.guard';
import { SetPasswordGuard } from '@core/guard/setPass-guard';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

export const authRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  {
    path: 'set-password/:token',
    component: ResetPasswordComponent,
    canActivate: [SetPasswordGuard],
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
    canActivate: [ResetPasswordGuard],
  },
];
